export enum JobType {
  ORDERS = 'orders',
  ORDERS_BY_PAYMENT_METHOD = 'orders_by_payment_method',
  SALES = 'sales',
  PDF_BILLING_SHORT = 'pdf_billing_short',
  PDF_BILLING_LONG = 'pdf_billing_long',
}
